import { render, staticRenderFns } from "./StandardAgreement.vue?vue&type=template&id=0be8a73c&"
import script from "./StandardAgreement.vue?vue&type=script&lang=js&"
export * from "./StandardAgreement.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports